<template>
  <div
    class="resourceUpLoad"
    :class="{
      small: size == 'small',
      enough:
        $refs['el-upload'] && $refs['el-upload'].uploadFiles.length == limit,
    }"
  >
    <el-form-item :label="label" :prop="prop">
      <el-upload
        ref="el-upload"
        :action="$store.state.appConfig.baseURL + 'api/resource/upload/'"
        :headers="{ 'Access-Token': $store.state.session.token }"
        :data="{ file_type, usage }"
        :list-type="listType"
        :show-file-list="true"
        :file-list="fileList"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :on-remove="removeSuccess"
        :before-upload="beforeUpload"
        :disabled="disabled"
        multiple
        :limit="limit"
      >
        <!-- <el-button size="small" type="primary">点击上传</el-button> -->
        <i class="el-icon-plus"></i>

        <div slot="file" slot-scope="{ file }" style="height: 100%">
          <!-- v-if="checkIsImage(file.url)" -->

          <el-image
            :src="file.url"
            fit="contain"
            :preview-src-list="
              $refs['el-upload'].uploadFiles.map((item) => item.url)
            "
            style="width: 100%; height: 100%"
          >
            <div
              slot="error"
              style="
                line-height: 1rem;
                display: flex;
                justify-content: center;
                flex-direction: column;
                height: 100%;
                text-align: center;
              "
            >
              <!-- <div>图片加载失败</div> -->
              <i
                class="el-icon-folder"
                style="font-size: 6rem; cursor: pointer"
              ></i>
            </div>
          </el-image>
          <div v-if="!disabled" class="remove" @click="handleDelete(file)">
            <i class="el-icon-close"></i>
          </div>

          <!-- <span class="el-upload-list__item-actions">
            <span
              class="el-upload-list__item-preview"
              @click="handlePreview(file.url)"
            >
              <i class="el-icon-zoom-in"></i>
            </span>
            <span
              v-if="!disabled"
              class="el-upload-list__item-preview"
              @click="handleDelete(file)"
            >
              <i class="el-icon-delete"></i>
            </span>
          </span> -->
        </div>
      </el-upload>
      <div class="uploadEmpty" v-if="disabled && !initResourceUrl.length">
        {{l("暂无")}}
      </div>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "ResourceListUpLoad",
  props: {
    initResourceUrl: {
      type: Array,
      default: () => [],
    },
    label: String,
    prop: String,
    disabled: Boolean,
    usage: String,
    maxSize: {
      type: Number,
      default: 5, //mb
    },
    file_type: {
      type: String,
      default: "image", //image,wgt,apk,document,video
    },
    limit: {
      type: Number,
      default: 9,
    },
    size: {
      type: String,
      default: "medium",
    },
  },
  data() {
    return {
      body: {
        file_type: this.file_type,
      },
      //原本就有的图片列表
      fileList: [],
    };
  },
  computed: {
    //此处遇到的问题为 text模式无法预览，只能在新增时使用，但编辑时无法看到文件
    //picture-card模式传非图片文件又会破碎
    listType() {
      // if (this.disabled) {
      return "picture-card";
      // } else {
      //   return "text";
      // }
    },
  },
  created() {
    //FIXME
    //本Component创建时，initResourceUrl可能还在等接口返回，
    //但监听initResourceUrl又会在新增或删除图片时触发监听导致重新触发fileList动画，
    //最终方案为initResourceUrl加载完毕后父元素手动调用该方法
    //或加载完毕后再显示本组件
    this.InitFileList();
  },
  mounted() {},
  methods: {
    InitFileList() {
      this.$nextTick(() => {
        if (this.initResourceUrl.length) {
          //图片列表的初始值,{url:XXX}形式
          this.fileList = this.initResourceUrl.map((item) => ({
            url: item,
          }));
        } else {
          this.fileList = [];
        }
      });
    },
    uploadSuccess(res, file) {
      console.log(res);
      console.log(file);
      console.log(file.raw);
      this.updateParent();
    },
    uploadError(err, file, fileList) {
      if (err.status == 401) {
        this.$alert("登录已失效", "请求出错", {
          confirmButtonText: "确定",
          callback: () => {
            this.$store.commit("logout");
          },
        });
      } else {
        this.$alert(err || "文件上传失败", "请求出错", {
          confirmButtonText: "确定",
        });
      }
    },
    handleDelete(file) {
      // console.log(file, this.fileList, this.$refs["el-upload"].uploadFiles);
      console.log('this.$refs["el-upload"]', this.$refs["el-upload"]);
      var index = this.$refs["el-upload"].uploadFiles.findIndex(
        (item) => item.uid == file.uid
      );
      this.$refs["el-upload"].uploadFiles.splice(index, 1);
      this.removeSuccess();
    },
    removeSuccess() {
      //只有用组件自带的删除才会自动触发，自定义的删除需要手动触发
      this.updateParent();
    },
    updateParent() {
      this.$emit(
        "update:initResourceUrl",
        this.$refs["el-upload"].uploadFiles.map((item) => {
          if (item.response) {
            return item.response.data;
          } else {
            return item.url;
          }
        })
      );
    },
    beforeUpload(file) {
      //过滤文件类型
      let nextFlag = false;
      let message = "";

      var fileNameSplitList = file.name.split(".");
      const suffix =
        fileNameSplitList[fileNameSplitList.length - 1].toLowerCase();
      for (var item in this.$utils.type_suffix) {
        if (this.file_type.indexOf(item) != -1) {
          if (this.$utils.type_suffix[item].indexOf(suffix) != -1) {
            nextFlag = true;
          } else {
            message += " " + this.$utils.type_suffix[item] + " ";
          }
        }
      }
      if (!nextFlag) {
        this.$message.error(`仅支持${message}资源的上传!`);
        return false;
      }
      //过滤文件大小
      if (this.maxSize) {
        if (file.size / 1024 / 1024 > this.maxSize) {
          this.$message.error(`上传资源大小不能超过 ${this.maxSize}MB!`);
          return false;
        }
      }
    },
    handlePreview(url) {
      window.open(url);
    },
    checkIsImage(url) {
      if (!url) {
        return false;
      }
      var fileNameSplitList = url.split(".");
      var suffix =
        fileNameSplitList[fileNameSplitList.length - 1].toLowerCase();
      if (this.$utils.type_suffix.image.indexOf(suffix) != -1) {
        return true;
      } else {
        return false;
      }
    },
    clearFiles() {
      this.$refs["el-upload"].clearFiles();
    },
  },
};
</script>

<style scoped lang="scss">
//右上角奇怪箭头
/deep/.el-upload-list__item-status-label {
  display: none !important;
}

//disabled时隐藏上传图片按钮
/deep/.is-disabled + .el-upload.el-upload--picture-card {
  display: none;
}

/deep/.el-upload-list__item-preview {
  i {
    cursor: pointer;
  }
}

.uploadEmpty {
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
  border-radius: 6px;
  box-sizing: border-box;
  border: 1px solid $infoColor;
}
/deep/.el-upload--picture-card {
  //为了让+号居中
  line-height: 158px;
}

.small {
  $smallWidth: 40px;
  /deep/.el-upload-list__item {
    width: $smallWidth;
    height: $smallWidth;
  }
  .uploadEmpty {
    width: $smallWidth;
    height: $smallWidth;
  }
  /deep/.el-upload--picture-card {
    width: $smallWidth;
    height: $smallWidth;
    line-height: $smallWidth;
  }
  /deep/.el-form-item {
    margin-bottom: 0;
  }
  /deep/.uploadEmpty {
    line-height: $smallWidth;
  }
  .el-icon-plus {
    font-size: 18px;
  }

  .remove {
    right: 0px;
    top: 0px;
    padding: 2px;
    background: $dangerColor;
    &:hover {
      i {
        color: #fff !important;
      }
    }
  }
}

.remove {
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  position: absolute;
  right: 4px;
  top: 4px;
  padding: 4px;
  z-index: 10;
  i {
    display: block !important;
    opacity: 1 !important;
    color: #fff !important;
    font-size: 12px !important;
    position: initial !important;
    font-weight: bold;
  }
  &:hover {
    i {
      color: $dangerColor !important;
    }
  }
}

.enough {
  /deep/.el-upload--picture-card {
    display: none;
  }
}
</style>
